import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

// 2026-10-27 — send a purchase order to anyone, even a vendor that isn't on
// ScapeSource: type their name and email. They're added to this company's
// network privately (nobody else sees them), the PO email carries the PDF,
// and a "join the network free" link lets them sign up and claim that
// same record. Someone already on ScapeSource is simply found.
export default function VendorByEmailDialog({ open, onOpenChange, onCreated }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [saving, setSaving] = useState(false);

  const close = (v) => { onOpenChange(v); if (!v) { setName(""); setEmail(""); } };

  const save = async () => {
    if (!name.trim() || !email.trim()) return toast.error("Enter the vendor's name and email");
    setSaving(true);
    try {
      const { data } = await api.post("/contractor/vendors/by-email", { name: name.trim(), email: email.trim() });
      toast.success(data.registered
        ? `${data.name} is already on ScapeSource — added to your network`
        : data.existing ? `${data.name} was already in your network` : `${data.name} added — their POs are emailed with a link to join free`);
      close(false);
      onCreated?.(data);
    } catch (e) {
      const d = e.response?.data?.detail;
      toast.error(Array.isArray(d) ? d.map((x) => x.message || x.msg).join(" ") : d || "Couldn't add that vendor");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent data-testid="vendor-by-email-modal">
        <DialogHeader><DialogTitle>Send to someone not on ScapeSource</DialogTitle></DialogHeader>
        <p className="text-[12.5px] text-slate-500">
          Type who the purchase order is for. They don't need to be on ScapeSource: the PO is emailed to them as a PDF, with a link to join the network free.
        </p>
        <div className="space-y-3 mt-1">
          <div>
            <label className="text-[13px] font-medium">Vendor name *</label>
            <input value={name} onChange={(e) => setName(e.target.value)} data-testid="by-email-name" className="mt-1.5 w-full h-10 px-3 rounded-lg border border-slate-200 text-sm" />
          </div>
          <div>
            <label className="text-[13px] font-medium">Email *</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="by-email-email" placeholder="orders@vendor.com" className="mt-1.5 w-full h-10 px-3 rounded-lg border border-slate-200 text-sm" />
          </div>
          <button disabled={saving} onClick={save} data-testid="by-email-save" className="w-full h-10 rounded-lg bg-sky-500 text-white text-[13px] font-semibold disabled:opacity-60">
            {saving ? "Adding…" : "Add vendor"}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
